window.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".video-gallery-section").forEach(function (root) {
    function embedVideo(videoId, container) {
      if (!videoId || !container) return;
      if (container.querySelector("iframe")) return;
      var iframe = document.createElement("iframe");
      iframe.src = "https://www.youtube.com/embed/" + videoId;
      iframe.loading = "lazy";
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("title", "Customer video review");
      iframe.setAttribute("frameborder", "0");
      container.appendChild(iframe);
    }

    function setCurrentPage(pageLinks, index) {
      for (var p = 0; p < pageLinks.length; p++) {
        var wrap = pageLinks[p].closest(".page") || pageLinks[p].parentElement;
        if (wrap) wrap.classList.remove("current");
        pageLinks[p].classList.remove("current");
        pageLinks[p].removeAttribute("aria-current");
      }
      if (!pageLinks[index]) return;
      var activeWrap = pageLinks[index].closest(".page") ||
        pageLinks[index].parentElement;
      if (activeWrap) activeWrap.classList.add("current");
      pageLinks[index].classList.add("current");
      pageLinks[index].setAttribute("aria-current", "page");
    }

    function fillPage(pageIndex) {
      var pageEl = dataSets[pageIndex];
      if (!pageEl) return;
      var containers = pageEl.querySelectorAll(".video-container");
      var start = perPage * pageIndex;
      for (var i = 0; i < containers.length; i++) {
        var id = videoIds[start + i];
        if (id) embedVideo(id, containers[i]);
      }
    }

    function showPage(pageIndex) {
      if (pageIndex < 0 || pageIndex >= dataSets.length) return;
      for (var e = 0; e < dataSets.length; e++) {
        dataSets[e].classList.toggle("active", e === pageIndex);
      }
      setCurrentPage(pageLinks, pageIndex);
      fillPage(pageIndex);
    }

    var idEl = root.querySelector("[data-set-video-id]");
    var paginateEl =
      root.querySelector(".video-gallery__pagination .paginate") ||
      root.querySelector(".paginate");
    var dataSets = root.querySelectorAll(".data-set");
    if (!idEl || !dataSets.length) return;

    var videoIds = (idEl.textContent || "")
      .split(",")
      .map(function (id) {
        return id.replace(/\s+/g, "");
      })
      .filter(Boolean);
    var perPage = parseInt(idEl.getAttribute("data-limit-per-page"), 10) || 9;
    var pageLinks = paginateEl
      ? paginateEl.querySelectorAll("a[data-paginate-button]")
      : [];

    showPage(0);

    for (var s = 0; s < pageLinks.length; s++) {
      (function (pageIndex) {
        pageLinks[pageIndex].addEventListener("click", function (event) {
          event.preventDefault();
          showPage(pageIndex);
        });
      })(s);
    }
  });
});
